import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as esAPI from '../../lib/api/esapi';
import { takeLatest } from 'redux-saga/effects';
import { findIndex, remove, forEach } from 'lodash';

// [START] API 서버에 Request ------------------------->

// 견적서 정보 
const [
    REQ_ES_INFO,
    REQ_ES_INFO_SUCCESS,
    REQ_ES_INFO_FAILURE,
] = createRequestActionTypes('order/REQ_ES_INFO');

// 주문 
const [
    REQ_ORDER,
    REQ_ORDER_SUCCESS,
    REQ_ORDER_FAILURE,
] = createRequestActionTypes('order/REQ_ORDER');

// 견적서 상세 정보 
const [
    REQ_DETAIL_INFO,
    REQ_DETAIL_INFO_SUCCESS,
    REQ_DETAIL_INFO_FAILURE,
] = createRequestActionTypes('order/REQ_DETAIL_INFO');

// 주문 정보 
const [
    REQ_ORDER_INFO,
    REQ_ORDER_INFO_SUCCESS,
    REQ_ORDER_INFO_FAILURE,
] = createRequestActionTypes('order/REQ_ORDER_INFO');

// 멀티주문 
const [
    REQ_ORDER_MULTI,
    REQ_ORDER_MULTI_SUCCESS,
    REQ_ORDER_MULTI_FAILURE,
] = createRequestActionTypes('order/REQ_ORDER_MULTI');

const RESET_RES_CODE = createRequestActionTypes('order/RESET_RES_CODE');

/**
 * 견적서 요청 Action - Container 에서 요청 
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const reqEsItemInfoAction = createAction(REQ_ES_INFO, (param) => {
    return ({ param });
});

// 주문서 등록 
export const reqEsOrderAction = createAction(REQ_ORDER, (es_id, revname, mobile1, mobile2, reqdlrv, payinfo) => {
    return ({ es_id, revname, mobile1, mobile2, reqdlrv, payinfo });
});

// 견적서 상세 정보
export const reqEsDetailInfoAction = createAction(REQ_DETAIL_INFO, (param) => {
    return ({ param });
});

// 반환 코드 정보 Reset
export const reqEsOrderCodeReset = createAction(RESET_RES_CODE);

// 주문 상세 
export const reqEsOrderInfoAction = createAction(REQ_ORDER_INFO, (param) => {
    return ({ param });
});

// 주문서 등록 
export const reqEsMultiOrderAction = createAction(REQ_ORDER_MULTI, (es_id, revname, mobile1, mobile2, reqdlrv, count, payinfo) => {
    return ({ es_id, revname, mobile1, mobile2, reqdlrv, count, payinfo });
});
/**
 * SAGA API 에서 REST API 호출 
 */
const reqEsItemInfoSaga = createRequestSaga(REQ_ES_INFO, esAPI.getMultiEsInfo);
const reqEsOrderSaga = createRequestSaga(REQ_ORDER, esAPI.orderEs);
const reqEsDetailSaga = createRequestSaga(REQ_DETAIL_INFO, esAPI.getEsDetailInfo);
const reqEsOrderInfoSaga = createRequestSaga(REQ_ORDER_INFO, esAPI.getOrderInfo);
const reqEsMultiOrderSaga = createRequestSaga(REQ_ORDER_MULTI, esAPI.orderMultiEs);

export function* esOrderSaga() {
    yield takeLatest(REQ_ES_INFO, reqEsItemInfoSaga);
    yield takeLatest(REQ_ORDER, reqEsOrderSaga);
    yield takeLatest(REQ_DETAIL_INFO, reqEsDetailSaga);
    yield takeLatest(REQ_ORDER_INFO, reqEsOrderInfoSaga);
    yield takeLatest(REQ_ORDER_MULTI, reqEsMultiOrderSaga);
}
// [END] API 서버에 Request ------------------------------>


/**
 * Store에 저장될 값 
 */
const initialState = {
    esItemInfoRes: null,
    esItemInfo: null,
    esItemDetailInfo: null,
    esItemDetailRes: null,
    esOrderRes: null,
    esOrderInfo: null,
    error: null,
}

const esOrderReducer = handleActions(
    {
        [REQ_ES_INFO_SUCCESS]: (state, { payload }) => {
            state.esItemInfoRes = payload.code;

            //console.log("REQ_ES_INFO_SUCCESS + " + JSON.stringify(payload))
            if (payload.code === 600 || payload.code === 500) {
                state.esItemInfo = null;
            } else {
                state.esItemInfo = payload.data;
            }

            return ({
                ...state,
            })
        },
        [REQ_ES_INFO_FAILURE]: (state, { payload: error }) => {
            // state.esItemInfoRes = null;
            // state.esItemInfo = null;
            return ({
                ...state,
                error,
            })

        },
        [REQ_ORDER_SUCCESS]: (state, { payload }) => {
            state.esOrderRes = payload;
            return ({
                ...state,
            })
        },
        [REQ_ORDER_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_DETAIL_INFO_SUCCESS]: (state, { payload }) => {
            state.esItemDetailRes = payload.code;
            state.esItemDetailInfo = payload.data;
            return ({
                ...state,
            })
        },
        [REQ_DETAIL_INFO_FAILURE]: (state, { payload: error }) => {

            return ({
                ...state,
                error,
            })

        },
        [REQ_ORDER_INFO_SUCCESS]: (state, { payload }) => {
            //console.log("REQ_ORDER_INFO_SUCCESS = " + JSON.stringify(payload))
            state.esOrderInfo = payload;
            return ({
                ...state,
            })
        },
        [REQ_ORDER_INFO_FAILURE]: (state, { payload: error }) => {

            return ({
                ...state,
                error,
            })

        },
        [REQ_ORDER_MULTI_SUCCESS]: (state, { payload }) => {
            state.esOrderRes = payload;
            return ({
                ...state,
            })
        },
        [REQ_ORDER_MULTI_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [RESET_RES_CODE]: (state) => {
            //console.log("RESET_RES_CODE")
            return ({
                ...state,
                esItemDetailRes: null,
                esItemInfoRes: null,
                esOrderRes: null,
                esOrderInfo: null,
                error: null
            })
        }
    }
    , initialState);

export default esOrderReducer;
